import { FieldsOptions } from '@sim/form';

import { FilterFieldsOptions } from '@ui/ui.module';

export type MediaType = 'image/*' | 'image/jpg' | 'image/jpeg' | 'image/png' | 'application/pdf';

export type MediaExt = 'pdf' | 'jpg';

export interface Media {
  createdAt?: string;
  id?: string;
  note?: string;
  path: string;
  previewUrl: string;
  tags?: string[];
  type?: MediaType;
  name?: string;
  ext?: MediaExt;
}

export const MediaMeta: FieldsOptions<Media> = {
  ext: {},
  id: {},
  name: { value: '' },
  note: {},
  path: {},
  previewUrl: {},
  tags: { type: 'array' },
  type: {},
};

export interface MediaFilter {
  name?: string;
  note?: string;
  tags?: string;
  type?: string;
  ext?: string;
  notExt?: string; // TODO: Maybe a string[]
}

export const MediaFilterMeta: FilterFieldsOptions<MediaFilter> = {
  ext: { operator: 'equal' },
  name: { operator: 'contains' },
  notExt: { operator: 'not_equal', realField: 'ext' },
  note: { operator: 'contains' },
  tags: { operator: 'contains' },
};
